<section fxFlex="1 1 auto" fxLayout="row">
    <section *ngIf="projectItemList" fxLayout="column" class="px-4 sen-project-items" fxFlex="1 1 auto">
        <div fxFlex="1 1 auto" class="pt-2 sen-item-list overflow-auto">
            <mat-accordion class="mx-5 d-block" [multi]="true">
                <mat-expansion-panel class="my-3">
                    <mat-expansion-panel-header class="sen-light-blue-bg">
                        <h5 title="{{selectedProjectArray.name}}"><b>{{translate.getLng('PROJECT')}}: {{selectedProjectArray.name | truncate:30}}</b>
                        </h5>
                    </mat-expansion-panel-header>
                    <sen-app-items-price [tableData]="projectItemList.projectItems"></sen-app-items-price>
                </mat-expansion-panel>
                <ng-container *ngFor="let plan of projectItemList.roofPlanItems">
                    <mat-expansion-panel *ngIf="plan.panelID != selectedProjectArray.panelID" class="my-3">
                        <mat-expansion-panel-header class="sen-light-blue-bg">
                            <h5 title="{{plan.name}}" class="mt-3">{{translate.getLng('ROOF_PLAN')}}: {{plan.name | truncate: 30}}</h5>
                        </mat-expansion-panel-header>
                        <sen-app-items-quantity [tableData]="plan"></sen-app-items-quantity>
                    </mat-expansion-panel>
                </ng-container>
                <mat-expansion-panel class="my-3">
                    <mat-expansion-panel-header class="sen-light-blue-bg">
                        <h5 class="mt-3">{{translate.getLng('INVERTER_AC_DC')}}</h5>
                    </mat-expansion-panel-header>
                    <sen-app-items-quantity [tableData]="projectItemList.inverterPlanItems"></sen-app-items-quantity>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div class="text-right">
            <button mat-raised-button color="primary" class="py-1 px-4 m-2" (click)="pdfExport()">
                <mat-icon>picture_as_pdf</mat-icon> {{translate.getLng('PDF_EXPORT')}}
            </button>
            <button mat-raised-button (click)="addToCart()" color="primary" class="py-1">{{translate.getLng('GO_TO_SHOP')}}
            </button>
        </div>
    </section>
</section>
